module.exports = __webpack_public_path__ + "img/500.9532c547.png";